import { Component } from "react";
import { NSAHomePage, NSARouterMakerProps } from "namirasoft-account-react";
import { NWSRegionLayout } from "../NWSRegionLayout";

class HomePage extends Component<NSARouterMakerProps>
{
    override render()
    {
        return (
            <NWSRegionLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </NWSRegionLayout>
        );
    }
}

export default HomePage;